import React from 'react'
// react component for creating dynamic tables
import ReactTable from 'react-table'
import { withRouter } from 'react-router'

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment'
import DeleteForever from '@material-ui/icons/DeleteForever'
import ZoomIn from '@material-ui/icons/ZoomIn'

// core components
import Button from 'components/CustomButtons/Button.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.jsx'
import { deleteRecord } from '../../services/generalServiceAPI'
import AppContext from '../../services/context'
import {  reactTableFilterCaseInsensitive } from '../utility/utility'

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
}

class containerTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      loading: true,
    }
  }
  static contextType = AppContext
  componentDidMount() {
    const filter = localStorage.getItem('routeFilter')
    this.setState({ ...JSON.parse(filter), loading: false })
  }
  componentWillUnmount() {
    const { filtered } = this.state
    localStorage.setItem('routeFilter', JSON.stringify({ filtered }))
  }
  // This component gets data from props not state since there is no in-place editing allowed
  // The way to retrive data in the above method- didMount seems more neat than 'render function binding', but will keep using the binding way
  // since that's what they recommand and seems the error handling is more standard
  render() {
    const { classes, signingPaths, history } = this.props
    // console.log(this.props)
    return (
      <GridContainer>
        {/* {jsonPP(this.state)} */}
        <GridItem xs={12}>
          <Card>
            <CardHeader color='primary' icon>
              <CardIcon color='primary'>
                <Assignment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Signing Path </h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={signingPaths}
                filterable
                loading={this.state.loading}
                filtered={this.state.filtered}
                overflow='hidden'
                defaultFilterMethod={(filter, row) => reactTableFilterCaseInsensitive(filter, row)}
                onFilteredChange={(filtered) => {
                  this.setState({ filtered })
                }}
                //overflow="hidden"
                columns={[
                  {
                    Header: 'Name',
                    accessor: 'name',
                    width: 200,
                    filterable: true,
                  },
                  {
                    Header: 'Comany',
                    accessor: 'company.name',
                    width: 200,
                    filterable: true,
                  },
                  {
                    Header: 'Levels',
                    id: 'numberOfLevels',
                    accessor: 'numberOfLevels', //d => d.company.name,
                    width: 200,
                    filterable: false,
                  },
                  {
                    Header: 'Receivers',
                    id: 'receiverGroup',
                    accessor: 'receiverGroup.name',
                    filterable: false,
                  },
                  // {
                  //   Header: 'Deployed',
                  //   id: 'Deployed',
                  //   accessor: d => (d.isDeployed ? 'True' : 'False'),
                  //   filterable: false
                  // },
                  // {
                  //   Header: 'Description',
                  //   accessor: 'description',
                  //   filterable: false
                  // },
                  {
                    Header: () => <div style={{ textAlign: 'left' }}>Actions</div>,
                    id: 'actions',
                    filterable: false,
                    sortable: false,
                    accessor: (d) => (
                      <div>
                        <Button
                          justIcon
                          round
                          simple
                          onClick={(e) => {
                            // console.log(d)
                            this.context.signingPath = d
                            history.push('/systemadmin/update-signingpath')
                          }}
                          color='primary'
                        >
                          <ZoomIn className={classes.icon} />
                        </Button>
                        {d.isDeployed ? (
                          ''
                        ) : (
                          <Button
                            justIcon
                            round
                            simple
                            onClick={async (e) => {
                              await deleteRecord({ id: d.id, tableName: 'signingPaths', refetch: this.props.refetch })
                            }}
                            color='primary'
                          >
                            <DeleteForever className={classes.icon} />
                          </Button>
                        )}
                      </div>
                    ),
                  },
                  // {
                  //   //fix alignment bug
                  //   width: -1,
                  //   filterable: false
                  // }
                ]}
                // getTrProps={(state, rowInfo) => {
                //   return {
                //     onClick: e => {
                //       // console.log(state, rowInfo)
                //       // this.context.signingPath = rowInfo.original
                //       // history.push('/systemadmin/update-signingpath')
                //     }
                //   }
                // }}
                defaultPageSize={10}
                //minRow={3}
                //headClassname=""
                showPaginationTop={false}
                showPaginationBottom={true} //={true} //can be ignored
                className='-striped -highlight'
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }
}

export default withRouter(withStyles(styles)(containerTable))
